var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewSvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#FBFFB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20C17.8978 20 18.2794 19.8525 18.5607 19.5899C18.842 19.3274 19 18.9713 19 18.6V10.2L14.5 6H8.5C8.10218 6 7.72064 6.1475 7.43934 6.41005C7.15804 6.6726 7 7.0287 7 7.4V18.6C7 18.9713 7.15804 19.3274 7.43934 19.5899C7.72064 19.8525 8.10218 20 8.5 20H17.5ZM13.75 7.4L17.5 10.9H13.75V7.4ZM9.25 10.2H11.5V11.6H9.25V10.2ZM9.25 13H16.75V14.4H9.25V13ZM9.25 15.8H16.75V17.2H9.25V15.8Z",
    fill: "#FFC300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSvgIcon);
export default __webpack_public_path__ + "static/media/viewSVGIcon.66ba4437905a0cf5e565f6f932126293.svg";
export { ForwardRef as ReactComponent };